import React, { Fragment, useState, useEffect, useCallback } from "react";
import Select from "react-select";
import {
  CalendarIcon,
  CheckIcon,
  CloudDownloadIcon,
  CogIcon,
  DotsHorizontalIcon,
  DownloadIcon,
  HomeIcon,
  PlusIcon,
  SearchIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import {
  Form,
  Button,
  InputGroup,
  Dropdown,
  Nav,
  Card,
  Table,
  OverlayTrigger,
  Tooltip,
  Pagination,
  Breadcrumb,
  Col,
  Row,
  Tab,
  ButtonGroup,
} from "react-bootstrap";
import {
  useDeleteCampListMutation,
  useDnldCampaignsMutation,
  useGetCampaignListMutation,
  useViewBillsMutation,
} from "Services/services";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { Routes } from "routes";
import Datetime from "react-datetime";
import { useLocation } from "react-router-dom";
import { FcCancel } from "react-icons/fc";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { TbReportMoney } from "react-icons/tb";
import hasPermission from "pages/Permissions";
import { downloadBlobFile } from "components/Utility";

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: "btn btn-secondary me-3",
      cancelButton: "btn btn-gray",
    },
    buttonsStyling: false,
  })
);

export default () => {
  // Get the user type from localStorage :: UI
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userType = userObject.user_type;
  const userID = userObject.id;

  // affects Tab UI only after routing from another component
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(
    location.state?.activeTab || "SMS"
  );
  // affects API response as well as data Table
  const [channelType, setChannelType] = useState("SMS");

  // const [showToast, setShowToast] = useState(false);
  // const [toastMessage, setToastMessage] = useState('');
  // const [toastVariant, setToastVariant] = useState('success');

  const [tableData, setTableData] = useState([]);

  // const [bulkOption, setBulkOption] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [status, setStatus] = useState("");
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [CampaignList] = useGetCampaignListMutation();
  const [deleteListApi] = useDeleteCampListMutation();
  const [download] = useDnldCampaignsMutation();

  const [viewBills] = useViewBillsMutation();
  // const [htmlContent, setHtmlContent] = useState('');

  const OpenBills = (id) => {
    viewBills({
      user_id: userID, // Replace with dynamic user ID if needed
      campaignId: id,
    startDate: start ? start.format("YYYY-MM-DD") : "",
      endDate: end ? end.format("YYYY-MM-DD") : "",
    })
      .then((htmlContent) => {
        // Create a Blob from the HTML content
        const blob = new Blob([htmlContent.data], { type: "text/html" });
        const url = URL.createObjectURL(blob);

        // Open the Blob URL in a new tab
        window.open(url, "_blank");
      })
      .catch((error) => {
        console.error("Error fetching bills:", error);
        SwalWithBootstrapButtons.fire(
          "Failed",
          "Error fetching the bill.",
          "error"
        );
      });
  };

  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 2000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const fetchTableData = async () => {
    try {
      const response = await CampaignList({
        user_id:
          userType === "super_admin" || userType === "admin" ? "" : userID,
        page: currentPage,
        limit: pagelimit,
        status: status?.value,
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        campaign_type: channelType,
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.result?.data || []);
        setTotalPages(response?.data?.data?.result?.totalPages || 0);
        setTotalPosts(response?.data?.data?.result?.totalPosts || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, [
    currentPage,
    pagelimit,
    status,
    debouncedValue,
    start,
    end,
    channelType,
  ]);

  const changeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };
  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const deleteUsers = async (ids) => {
    const usersToBeDeleted = ids;
    // const usersNr = usersToBeDeleted.length;
    const textMessage = "Are you sure do you want to delete this template?";

    const result = await SwalWithBootstrapButtons.fire({
      icon: "error",
      title: "Confirm deletion",
      text: textMessage,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      const newUsers = tableData.filter(
        (f) => !usersToBeDeleted.includes(f.id)
      );

      deleteListApi({ id: ids })
        .then((response) => {
          if (response?.data?.statusCode === 200) {
            setMessage("The List has been deleted.");
            setTableData(newUsers);
          } else {
            setError("Failed to Delete.");
          }
        })
        .catch((error) => {
          setError("Error deleting this list." || error);
        });

      if (message !== "") {
        await SwalWithBootstrapButtons.fire("Deleted", message, "success");
      } else {
        await SwalWithBootstrapButtons.fire("Failed", error, "error");
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const canDownload = hasPermission("Campaign", "download");
  const canEdit = hasPermission("Campaign", "edit");
  const canDelete = hasPermission("Campaign", "delete");

  const handleDownload = async () => {
    try {
      const blob = await download({
        user_id:
          userType === "super_admin" || userType === "admin" ? "" : userID,
        user_type: userType,
        status: status?.value,
        campaign_type: channelType,
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "Campaigns_List.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };

  const TableRow = (props) => {
    const statusVariant =
      props.status === "completed"
        ? "success"
        : props.status === "pending"
        ? "purple"
        : props.status === "cancelled"
        ? "danger"
        : props.status === "paused"
        ? "warning"
        : "primary";

    return (
      <tr className="border-bottom">
        <td>
          <span title={props.campaign_name||'-'} className="fw-normal">{props.campaign_name||"-"}</span>
        </td>
        <td>
          <span title={props.user_details||'-'} className="fw-normal">{props.user_details||"-"}</span>
        </td>
        <td>
          <span title={props.status||'-'} className={`fw-normal text-capitalize text-${statusVariant}`}>
            {props.status||"-"}
          </span>
        </td>
        {channelType === "SMS" && (
          <td>
            <span title={props.country||'-'} className="fw-normal">{props.country||"-"}</span>
          </td>
        )}
        <td>
          <span title={props.payment_status||'-'} className={`fw-normal text-capitalize`}>
            {props.payment_status||"-"}
          </span>
        </td>
        <td>
          <span title={props.contact_list_count||'-'} className="fw-normal">{props.contact_list_count||"-"}</span>
        </td>
        {channelType === "SMS" ? (
          <td>
            <span title={props.header||'-'} className="fw-normal">{props.header||"-"}</span>
          </td>
        ) : channelType === "WhatsApp" ? (
          <td>
            <span title={props.waba_mobile||'-'} className="fw-normal">{props.waba_mobile||"-"}</span>
          </td>
        ) : (
          <td>
            <span title="-" className="fw-normal">-</span>
          </td>
        )}
        <td>
          <span title={props.contact_mode||'-'} className="fw-normal">{props.contact_mode||"-"}</span>
        </td>
        <td>
          <span title={props.schedule||'-'} className="fw-normal">{props.schedule||"-"}</span>
        </td>
        <td>
          {props.status === "completed" ? (
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip className="m-0">View Bills</Tooltip>}
            >
              <Card.Link onClick={() => OpenBills(props.id)}>
                <TbReportMoney
                  style={{ width: "20px", height: "20px" }}
                  className="icon icon-xxs text-info"
                />
              </Card.Link>
            </OverlayTrigger>
          ) : (
            <span className="fw-normal">"N/A"</span>
          )}
        </td>
        <td>
          <span className="fw-normal" title={moment(props.createdAt).format("DD/MM/YYYY")||'-'}>
            {moment(props.createdAt).format("DD/MM/YYYY")}
          </span>
        </td>
        <td>
          <span className="fw-normal" title={moment(props.campaign_start).format("DD/MM/YYYY")||'-'}>
            {moment(props.campaign_start).format("DD/MM/YYYY")}
          </span>
        </td>
        {(canEdit || canDelete) && (
          <td>
            {canEdit &&
              props.status !== "cancelled" &&
              userType === "enterprise" && (
                <Dropdown as={ButtonGroup}>
                  <Dropdown.Toggle
                    as={Button}
                    split
                    variant="link"
                    className="text-dark m-0 p-0"
                    aria-label="Campaign options"
                  >
                    <DotsHorizontalIcon className="icon icon-xs" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start py-1">
                    <Dropdown.Item className="d-flex align-items-center">
                      <FcCancel className="dropdown-icon me-2" />
                      Cancel Campaign
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            {canDelete && (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip className="m-0">Delete</Tooltip>}
              >
                <Card.Link
                  className="ms-2"
                  onClick={() => deleteUsers(props.id)}
                >
                  <XCircleIcon className="icon icon-xs text-danger" />
                </Card.Link>
              </OverlayTrigger>
            )}
          </td>
        )}
      </tr>
    );
  };

  return (
    <Fragment>
      <Tab.Container
        defaultActiveKey={activeKey}
        onSelect={(key) => {
          setActiveKey(key);
          setChannelType(key);
          setPagelimit(10);
          setCurrentPage(1);
          setStart(null);
          setEnd(null);
        }}
      >
        <Card className="p-2">
          <Nav fill variant="pills" className="flex-lg-nowrap gap-2">
            <Nav.Item>
              <Nav.Link eventKey="SMS">SMS</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="WhatsApp">WhatsApp</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="RCS">RCS</Nav.Link>
            </Nav.Item>
          </Nav>
        </Card>

        <Tab.Content className="mt-0 mt-lg-3">
          <Tab.Pane eventKey={channelType}>
            <Card border={1}>
              <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                <InputGroup className="d-flex flex-nowrap fmxw-300">
                  <InputGroup.Text>
                    <SearchIcon className="icon icon-xs" />
                  </InputGroup.Text>
                  <Form.Control
                    type="search"
                    placeholder="Campaign Name/Header"
                    value={searchValue}
                    onChange={changeSearchValue}
                  />
                </InputGroup>
                <div className="fmxw-300">
                  <Select
                    options={[
                      { value: "pending", label: "Pending" },
                      { value: "running", label: "Running" },
                      { value: "paused", label: "Paused" },
                      { value: "completed", label: "Completed" }
                    ]}
                    value={status}
                    onChange={(option) => setStatus(option)}
                    isClearable
                    placeholder="Select Status"
                    styles={{
                      container: (provided) => ({
                        ...provided,
                        minWidth: '210px', // Set minimum width to handle longer labels
                        maxWidth: '250px', // Set maximum width to prevent it from being too wide
                      }),
                    }}
                  />
                </div>
                <Form.Group id="DateRange">
                  <InputGroup className="d-flex flex-nowrap">
                    <InputGroup.Text
                      onClick={() => {
                        setStart(null);
                        setEnd(null);
                      }}
                    >
                      {start || end ? (
                        <XCircleIcon className="icon icon-xs" />
                      ) : (
                        <CalendarIcon className="icon icon-xs" />
                      )}
                    </InputGroup.Text>
                    <Datetime
                      timeFormat={false}
                      onChange={(date) => {
                        if (moment.isMoment(date)) {
                          setStart(date);
                        }
                      }}
                      closeOnSelect={true}
                      renderInput={(props, openCalendar) => (
                        <Form.Control
                          type="search"
                          placeholder="Start Date"
                          value={
                            start ? moment(start).format("DD/MM/YYYY") : ""
                          }
                          onFocus={openCalendar}
                          readOnly
                          style={{ width: "150px", borderRadius: "0" }}
                        />
                      )}
                    />
                    <Datetime
                      timeFormat={false}
                      onChange={(date) => {
                        if (moment.isMoment(date)) {
                          setEnd(date);
                        }
                      }}
                      closeOnSelect={true}
                      isValidDate={(currDate) => currDate.isAfter(start)}
                      initialViewDate={end}
                      renderInput={(props, openCalendar) => (
                        <Form.Control
                          type="search"
                          placeholder="End Date"
                          value={end ? moment(end).format("DD/MM/YYYY") : ""}
                          onFocus={openCalendar}
                          readOnly
                          style={{
                            width: "150px",
                            borderTopLeftRadius: "0",
                            borderBottomLeftRadius: "0",
                          }}
                        />
                      )}
                    />
                  </InputGroup>
                </Form.Group>

                <div className="ms-auto d-inline-flex gap-2">
                  {canEdit && (
                    <Button
                      as={Link}
                      to={Routes.CreateCampaign.path}
                      variant="secondary"
                      size="sm"
                      className="d-inline-flex align-items-center"
                    >
                      <PlusIcon className="icon icon-xs me-2" /> New Campaign
                    </Button>
                  )}
                  {canDownload && (
                    <Button
                      variant="outline-gray-300"
                      className="p-2"
                      onClick={handleDownload}
                    >
                      <DownloadIcon className="icon icon-sm" />
                    </Button>
                  )}

                  <Dropdown className="">
                    <Dropdown.Toggle
                      split
                      as={Button}
                      variant="outline-gray-300"
                      className="text-dark m-0 p-2"
                    >
                      <CogIcon className="icon icon-sm" />
                      <span className="visually-hidden">Toggle Dropdown</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
                      <span className="small ps-2 fw-bold text-dark">Show</span>
                      {[10, 20, 30].map((limit) => (
                        <Dropdown.Item
                          key={limit}
                          className={`d-flex align-items-center fw-bold ${
                            limit === 30 ? "rounded-bottom" : ""
                          }`}
                          onClick={() => {
                            setPagelimit(limit); // Update the page limit
                            setCurrentPage(1); // Reset the page number to 1
                          }}
                        >
                          {limit}{" "}
                          {pagelimit === limit && (
                            <CheckIcon className="icon icon-xxs ms-auto" />
                          )}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <div className="custom-scroll-wrapper">
                <div className="scroll-container">
                  <Table
                    responsive
                    className="align-items-center table-flush table-outlines"
                  >
                    <thead className="thead-light">
                      <tr>
                        <th className="border-bottom">Campaign Name</th>
                        <th className="border-bottom">Enterprise User</th>
                        <th className="border-bottom">Status</th>
                        {channelType === "SMS" && (
                          <th className="border-bottom">Country</th>
                        )}
                        <th className="border-bottom">Payment Status</th>
                        <th className="border-bottom">Number of Contacts</th>
                        {channelType === "SMS" ? (
                          <th className="border-bottom">Header</th>
                        ) : channelType === "WhatsApp" ? (
                          <th className="border-bottom">WABA Number</th>
                        ) : (
                          <th className="border-bottom">Header</th>
                        )}
                        <th className="border-bottom">Contact List Type</th>
                        <th className="border-bottom">Schedule</th>
                        <th className="border-bottom" style={{minWidth:'80px'}}>Bills</th>
                        <th className="border-bottom">Created Date</th>
                        <th className="border-bottom">Campaign Start Date</th>
                        {(canEdit || canDelete) && (
                          <th className="border-bottom">Action</th>
                        )}
                      </tr>
                    </thead>
                    <tbody className="border-0">
                      {tableData.length > 0 ? (
                        tableData.map((u, index) => (
                          <TableRow key={index + 1} index={index + 1} {...u} />
                        ))
                      ) : (
                        <tr>
                          <td colSpan="15" className="text-center text-danger">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>

              <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
                <Nav>
                  <Pagination className="mb-0">
                    <Pagination.Prev
                      onClick={handlePrev}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </Pagination.Prev>
                    {currentPage >= 3 && (
                      <>
                        <Pagination.Item onClick={() => handlePageChange(1)}>
                          1
                        </Pagination.Item>
                        <Pagination.Ellipsis />
                      </>
                    )}
                    {currentPage > 1 && (
                      <Pagination.Item
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        {currentPage - 1}
                      </Pagination.Item>
                    )}
                    <Pagination.Item active>{currentPage}</Pagination.Item>
                    {currentPage < totalPages && (
                      <Pagination.Item
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        {currentPage + 1}
                      </Pagination.Item>
                    )}
                    {currentPage < totalPages - 1 && (
                      <>
                        <Pagination.Ellipsis />
                        <Pagination.Item
                          onClick={() => handlePageChange(totalPages)}
                        >
                          {totalPages}
                        </Pagination.Item>
                      </>
                    )}
                    <Pagination.Next
                      onClick={handleNext}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </Pagination.Next>
                  </Pagination>
                </Nav>
                <small className="fw-normal small mt-2 mt-md-0">
                  Showing{" "}
                  <b>
                    {totalPosts == 0
                      ? totalPosts
                      : pagelimit * (currentPage - 1) + 1}
                    -
                    {pagelimit * currentPage > totalPosts
                      ? totalPosts
                      : pagelimit * currentPage}
                  </b>{" "}
                  of <b>{totalPosts}</b> entries.
                </small>
              </Card.Footer>
            </Card>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Fragment>
  );
};
